export const convexClosure = function (trees) {
  const n = trees.length;
  if (n < 4) {
    return trees;
  }
  let bottom = 0;
  /** 找到 y 最小的点 bottom */
  for (let i = 0; i < n; i++) {
    if (trees[i][1] < trees[bottom][1]) {
      bottom = i;
    }
  }
  trees = swap(trees, bottom, 0);
  /* 以 bottom 原点，按照极坐标的角度大小进行排序 */
  trees.sort((a, b) => {
    let diff = cross(trees[0], a, b);
    return diff === 0 ? distance(trees[0], a) - distance(trees[0], b) : diff > 0 ? 1 : -1;
  });
  /* 对于凸包最后且在同一条直线的元素按照距离从大到小进行排序 */
  let r = n - 1;
  while (r >= 0 && cross(trees[0], trees[n - 1], trees[r]) === 0) {
    r--;
  }
  for (let l = r + 1, h = n - 1; l < h; l++, h--) {
    trees = swap(trees, l, h);
  }
  const stack = [trees[0], trees[1]];
  for (let i = 2; i < n; i++) {
    let top = stack.pop();
    /* 如果当前元素与栈顶的两个元素构成的向量顺时针旋转，则弹出栈顶元素 */
    while (cross(stack[stack.length - 1], top, trees[i]) > 0) {
      top = stack.pop();
    }
    stack.push(top);
    stack.push(trees[i]);
  }
  return stack;
};

const cross = (p, q, r) => {
  return (q[1] - p[1]) * (r[0] - q[0]) - (q[0] - p[0]) * (r[1] - q[1]);
};

const distance = (p, q) => {
  return (p[0] - q[0]) * (p[0] - q[0]) + (p[1] - q[1]) * (p[1] - q[1]);
};

const swap = (trees, i, j) => {
  let temp0 = trees[i][0];
  let temp1 = trees[i][1];
  trees[i][0] = trees[j][0];
  trees[i][1] = trees[j][1];
  trees[j][0] = temp0;
  trees[j][1] = temp1;
  return trees;
};

/**
 *
 * @param {number[]} data 多边形按照逆时针顺序排列的的点集
 * @param {number} sec_dis 缩放距离
 * @returns 缩放后的多边形点集
 */
export function polygonScale(data, sec_dis) {
  const num = data.length;
  const scal_data = [];
  for (let i = 1; i <= num; i++) {
    let x1 = data[i % num][0] - data[(i - 1) % num][0];
    let y1 = data[i % num][1] - data[(i - 1) % num][1];
    let x2 = data[(i + 1) % num][0] - data[i % num][0];
    let y2 = data[(i + 1) % num][1] - data[i % num][1];

    let d_A = (x1 ** 2 + y1 ** 2) ** 0.5;
    let d_B = (x2 ** 2 + y2 ** 2) ** 0.5;

    let Vec_Cross = x1 * y2 - x2 * y1;

    let sin_theta = Vec_Cross / (d_A * d_B);

    let dv = sec_dis / sin_theta;

    let v1_x = (dv / d_A) * x1;
    let v1_y = (dv / d_A) * y1;

    let v2_x = (dv / d_B) * x2;
    let v2_y = (dv / d_B) * y2;

    let PQ_x = v1_x - v2_x;
    let PQ_y = v1_y - v2_y;

    let Q_x = data[i % num][0] + PQ_x;
    let Q_y = data[i % num][1] + PQ_y;
    scal_data.push([Q_x, Q_y]);
  }
  return scal_data;
}

export function polygonScale2(polygon, expand) {
  let new_polygon = [];

  let len = polygon.length;
  for (let i = 0; i < len; i++) {
    let p = polygon[i];
    let p1 = polygon[i === 0 ? len - 1 : i - 1];
    let p2 = polygon[i === len - 1 ? 0 : i + 1];

    let v1x = p1[0] - p[0];
    let v1y = p1[1] - p[1];
    let n1 = norm(v1x, v1y);
    v1x /= n1;
    v1y /= n1;

    let v2x = p2[0] - p[0];
    let v2y = p2[1] - p[1];
    let n2 = norm(v2x, v2y);
    v2x /= n2;
    v2y /= n2;

    let l = -expand / Math.sqrt((1 - (v1x * v2x + v1y * v2y)) / 2);

    let vx = v1x + v2x;
    let vy = v1y + v2y;
    let n = l / norm(vx, vy);
    vx *= n;
    vy *= n;
    new_polygon.push([vx + p[0], vy + p[1]]);
  }

  return new_polygon;
}

function norm(x, y) {
  return Math.sqrt(x * x + y * y);
}

/**根据点集 生成一个包含所有点集的矩形，支持scale 控制缩放 */
export function getRectByPoints(points, scale = 1) {
  let minX = points[0][0];
  let minY = points[0][1];
  let maxX = points[0][0];
  let maxY = points[0][1];
  for (let i = 1; i < points.length; i++) {
    minX = Math.min(minX, points[i][0]);
    minY = Math.min(minY, points[i][1]);
    maxX = Math.max(maxX, points[i][0]);
    maxY = Math.max(maxY, points[i][1]);
  }

  // 返回按照scale 进行缩放的点坐标数组
  return [
    [minX - scale, minY - scale],
    [maxX + scale, minY - scale],
    [maxX + scale, maxY + scale],
    [minX - scale, maxY + scale]
  ];
}

/**
 * 根据点集和heading角度生成一个包含所有点集的矩形
 * 通过中心点旋转坐标系来计算边界矩形
 * @param {Array} points - 点集，格式为 [[x1, y1], [x2, y2], ...]
 * @param {number} scale - 缩放值，默认为1
 * @param {number} heading - 旋转角度，弧度制，默认为0
 * @returns {Array} - 旋转后的矩形顶点坐标
 */
export function getRotatedRectByPoints(points, scale = 1, heading = 0) {
  // 如果没有旋转角度，直接使用原来的函数
  if (heading === 0) {
    return getRectByPoints(points, scale, heading);
  }

  // 1. 计算所有点的中心点
  let sumX = 0;
  let sumY = 0;
  for (let i = 0; i < points.length; i++) {
    sumX += points[i][0];
    sumY += points[i][1];
  }
  const centerX = sumX / points.length;
  const centerY = sumY / points.length;

  // 2. 将点集相对于中心点进行-heading角度旋转（反向旋转到无旋转坐标系）
  const unrotatedPoints = points.map(point => {
    // 先将点相对于中心点平移
    const translatedX = point[0] - centerX;
    const translatedY = point[1] - centerY;
    // 然后进行反向旋转
    const rotated = rotatePoint(translatedX, translatedY, -heading);
    // 返回旋转后的点
    return [rotated[0] + centerX, rotated[1] + centerY];
  });

  // 3. 计算未旋转点集的边界矩形（相对于原始中心点）
  let minX = unrotatedPoints[0][0];
  let minY = unrotatedPoints[0][1];
  let maxX = unrotatedPoints[0][0];
  let maxY = unrotatedPoints[0][1];

  for (let i = 1; i < unrotatedPoints.length; i++) {
    minX = Math.min(minX, unrotatedPoints[i][0]);
    minY = Math.min(minY, unrotatedPoints[i][1]);
    maxX = Math.max(maxX, unrotatedPoints[i][0]);
    maxY = Math.max(maxY, unrotatedPoints[i][1]);
  }

  // 4. 生成边界矩形的四个顶点（未旋转状态）
  const rectPoints = [
    [minX - scale, minY - scale],
    [maxX + scale, minY - scale],
    [maxX + scale, maxY + scale],
    [minX - scale, maxY + scale]
  ];

  // 5. 将矩形顶点相对于中心点按heading角度旋转到目标方向
  const finalRect = rectPoints.map(point => {
    // 先将点相对于中心点平移
    const translatedX = point[0] - centerX;
    const translatedY = point[1] - centerY;
    // 然后进行正向旋转
    const rotated = rotatePoint(translatedX, translatedY, heading);
    // 返回旋转后的点
    return [rotated[0] + centerX, rotated[1] + centerY];
  });

  return finalRect;
}

/**
 * 旋转点
 * @param {number} x - 点的x坐标
 * @param {number} y - 点的y坐标
 * @param {number} angle - 旋转角度（弧度制）
 * @returns {Array} - 旋转后的点坐标 [newX, newY]
 */
function rotatePoint(x, y, angle) {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const newX = x * cos - y * sin;
  const newY = x * sin + y * cos;
  return [newX, newY];
}
